<template>
    <div class="table-wrapper" style="padding-top: 24px">
        <div class="fchart-wrapper">
            <div class="aFlex fchart-top">
                <span class="ft-bold">请选择统计类型：</span>
                <div class="ft-top-label">人员分类</div>
                <RadioGroup size="small" v-model="isManager" @on-change="querySummaryAttendance">
                    <Radio label="">全部</Radio>
                    <Radio :label="0">建筑工人</Radio>
                    <Radio :label="1">管理人员</Radio>
                </RadioGroup>
                <div class="ft-top-label">出勤时间</div>
                <Tooltip max-width="150" theme="light" transfer content="出勤时间，一次最多只能查询31天">
                    <Icon type="ios-help-circle-outline" style="font-size: 20px; margin-right: 12px;"/>
                </Tooltip>
                <DatePicker style="width: 140px;margin-right: 12px;" type="date" placement="bottom-end" transfer placeholder="请选择开始日期" :options="soptions" :value="startTime" @on-change="onStart" ></DatePicker>
                <DatePicker style="width: 140px;" type="date" placement="bottom-end" transfer placeholder="请选择结束日期" :options="eoptions" :disabled="!startTime" :value="endTime" @on-change="onEnd" ></DatePicker>
                <!--<div class="ft-top-label">工种岗位</div>-->
                <!--<Select style="width: 120px;"-->
                        <!--@on-change="querySummaryAttendance"-->
                        <!--v-model="jobCode" placeholder="请选择统计类型" clearable>-->
                    <!--<Option v-for="(item,index) in projectStatus" :value="item.code" :key="index">{{ item.name }}</Option>-->
                <!--</Select>-->
            </div>
            <div class="ft-box">
                <div class="aFlex statistics-top">
                    <div class="ft-top-label" style="margin: 0">出勤总览</div>
                </div>
                <div class="statistics-pannel">
                    <ul class="aFlex line-bottom">
                        <li class="statistics-pannel-item" style="background-color: #3399FF">
                            <span>在岗人数</span>
                            <div class="statistics-pannel-num">{{formInline.workNumber}}<span class="unit">人</span></div>
                        </li>
                        <li class="statistics-pannel-item" style="background-color: #61DDAA">
                            <span>出勤总数</span>
                            <div class="statistics-pannel-num">{{formInline.attendanceNumber}}<span class="unit">人</span></div>
                        </li>
                        <li class="statistics-pannel-item" style="background-color: #65789B">
                            <span>考勤次数</span>
                            <div class="statistics-pannel-num">{{formInline.clockNumber}}<span class="unit">人次</span></div>
                        </li>
                        <li class="statistics-pannel-item" style="background-color: #F6BD16">
                            <span>出勤率</span>
                            <div class="statistics-pannel-num">{{formInline.attendanceRate || 0}}<span class="unit">%</span></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="fchart-box" style="margin-bottom: 0">
                <div class="aFlex fchart-box-top">
                    <span class="ft-bold">出勤统计</span>
                </div>
                <div class="fchart-bi" style="height: 455px" ref="checkBar">出勤统计</div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .ft-top-label{
        background-color: #ffffff;
        margin-left: 15px;
    }
    .line-bottom .statistics-pannel-item{
        margin-bottom: 0;
    }
   .fchart-top{
        padding:0;
        line-height: 32px;
    }
    .statistics-top{
        height: 48px;
        padding-top: 8px;
        border-bottom: 2px solid #DEDCE3;
        padding: 0px;
    }
    .table-wrapper {
        padding: 0 24px;
        padding-bottom: 24px;
        background: white;
        -webkit-box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 10%);
        box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 10%);
        border-radius: 4px;
    }
    .fchart-wrapper{
        padding: 0;
    }
    .statistics-pannel{
        padding-top: 24px
    }
</style>
<script>
    import {mapGetters} from 'vuex';
    export default {
        data(){
            return {
                eoptions: {},
                soptions: {
                    disabledDate (date) {
                        return (date.valueOf() >= new Date().getTime())
                    }
                },
                isManager:'',
                startEnd:[],
                startTime: '',
                endTime: '',
                jobCode:'',
                // 出勤统计
                checkBar:null,
                formInline:{
                    workNumber:'',
                    attendanceNumber:'',
                    clockNumber:'',
                    attendanceRate:'',
                },
                areaCode: localStorage.getItem('tenantAreaCode')
            };
        },
        computed:{
            ...mapGetters(['projectStatus']),
        },
        watch: {
            areaCode: function () {
                this.getPageData();
            },
        },
        created(){
        },
        mounted(){
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 工资发放情况
            this.checkBar = echarts.init(this.$refs.checkBar);

            //初始化 setOption
            this.initChart();
            //获取数据
            this.getPageData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.checkBar.resize();
            },
            initChart(){
                this.checkBar.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            icon:'rect',
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid:{
                            left: 60,
                            right:60,
                            top: 40,
                            // bottom: 5,
                        },
                        xAxis:{
                            name:'日期',
                            nameTextStyle:{
                                align:'right',
                                padding:[30,0,0,0]
                            },
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data: []


                        },
                        yAxis:[
                            {
                            name:'单位（人）',
                            type:'value',
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                },
                                axisLine:{
                                    show: false
                                },
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                            },
                            {
                            name:'出勤率（%）',
                            type:'value',
                            min: 0,
                            max: 100,
                            splitNumber : 5,
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                },
                                axisLine:{
                                    show: false
                                },
                            },
                            axisLine:{
                                show: false
                            },
                            // minInterval: 1,
                            },


                        ],
                        series: [
                            {
                                type: 'bar',
                                color: [ '#3399FF'],
                                name: '出勤总数（人）',
                                // barGap:'10%',
                                barCategoryGap: '5%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                 yAxisIndex: 0, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
                                data:[],
                            },
                            {
                                type: 'bar',
                                color: [ '#61DDAA'],
                                name: '在岗总数（人）',
                                // barGap:'10%',
                                barCategoryGap: '5%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                 yAxisIndex: 0, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
                                data:[],
                            },
                            {
                                type: 'line',
                                tooltip:{

                                },
                                color: [ '#65789B'],
                                name: '出勤率（%）',
                                yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
                                data:[],
                            },
                        ]
                    }
                );
            },
            // 选择 开始时间
            onStart(e){
                this.startTime=e;
                this.endTime='';
                const sdate = new Date(this.startTime).getTime();
                this.eoptions = {
                    disabledDate (date) {
                        return (date.valueOf() >= new Date().getTime()) || ( date.valueOf() > sdate + 86400000*30 ) || ( date.valueOf() < sdate - 86400000 );
                    }
                };
                // this.querySummaryAttendance();
            },
            // 选择 结束时间
            onEnd(e){
                this.endTime=e;
                this.querySummaryAttendance();
            },
            // 人员出勤监管查询
            querySummaryAttendance(){
                this.checkBar.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/sx/querySummaryAttendance',
                    data:{
                        areaCode:this.areaCode,
                        isManager:this.isManager,
                        startTime:this.startTime || '',
                        endTime:this.endTime || '',
                        jobCode:this.jobCode,
                    }
                }).then( (response)=> {
                    if (response.data){
                        this.formInline=response.data;
                        let countResults=response.data.countResults;
                        let xData=[];
                        countResults.attendance.forEach(item=>{
                            xData.push(item.name);
                        });
                        countResults.rate = countResults.rate ? countResults.rate: [];
                        for (let i=0; i<countResults.rate.length; i++) {
                            countResults.rate[i].value = (countResults.attendance[i].value / (countResults.register[i].value || 1) * 100).toFixed(2)
                        }
                        this.checkBar.hideLoading();
                        this.checkBar.setOption(
                            {
                                xAxis:{
                                    data: xData,
                                },
                                series:[
                                    {
                                        data: countResults.attendance,
                                    },
                                    {
                                        data: countResults.register,
                                    },
                                    {
                                        data: countResults.rate,
                                    }
                                ],
                                dataZoom: xData.length > 15 ? [
                                    {
                                        startValue : 0,
                                        endValue : 10,
                                        type: 'slider',
                                        show: true,
                                        xAxisIndex: [0],
                                        height: 10,
                                        bottom: 8,
                                        borderRadius: 5,
                                        showDataShadow: false,
                                        showDetail: false,
                                        realtime: true
                                    }
                                ] : []
                            }
                        );
                    }
                });
            },
            /* 获取页面数据 */
            getPageData(){
                this.querySummaryAttendance();
            },
        }
    };
</script>
